export const CHOOSE_LOB = 'Choose Your LOB'
export const NEW_LOB_ADDED = 'New LOB is added in our list.'
export const ADD_NEW_LOB = 'Add New LOB'
export const SUBMIT = 'Submit'
export const CANCEL = 'Cancel'
export const MAXIMUM_SIZE = 'Maximum Allowed Files Upload Size :'
export const LOB_ALREADY_PRESENT = 'This LOB is already present in our list.'